export const CATEGORIAS = {
    categorias: [
        {
            categoria: 'Escultura',
            filtro: 'esculturas',
            id: 1,
            subCategorias: [
                {
                    categoria: 'Barro',
                    filtro: 'barro',
                    id: 11
                },
                {
                    categoria: 'Esferovite',
                    filtro: 'esferovite',
                    id: 12
                },
                {
                    categoria: 'Fibra',
                    filtro: 'fibra',
                    id: 13
                },
                {
                    categoria: 'Gesso',
                    filtro: 'gesso',
                    id: 14
                },
                {
                    categoria: 'Madeira',
                    filtro: 'madeira',
                    id: 15
                },
            ]
        },
        {
            categoria: 'Pintura',
            filtro: 'pinturas',
            id: 2
        },
        {
            categoria: 'Acrílicos',
            filtro: 'acrilicos',
            id: 3
        },
        {
            categoria: 'Impressão Digital',
            filtro: 'impressao',
            id: 4
        },
        {
            categoria: 'Corte 2D, 3D e Laser',
            filtro: 'corte',
            id: 5,
        },
        {
            categoria: 'Adereços de Cenografia',
            filtro: 'cenografia',
            id: 6,
        },
        {
            categoria: 'Moldes',
            filtro: 'moldes',
            id: 7,
        },
        {
            categoria: 'Últimos Trabalhos',
            filtro: 'ultimos',
            id: 9
        }
    ],
    activeLink: null
}
